import { z } from 'zod';

import { TFunction } from '@/lib/translation/config';

export const heroFormSchema = (t: TFunction) =>
  z.object({
    email: z.string().email(t('auth.error.invalidEmail')),
  });

export type HeroFormData = z.infer<ReturnType<typeof heroFormSchema>>;
